<template>
  <div id="container">
    <div>
      <div>
        <img src="../assets/static/icons/expar_logo_new.svg" alt="expar_logo" />
        <span class="logo-text">
          expar
        </span>        
      </div>

      <br />
      <br />
      <div class="comingSoon">
        {{ $t('comingSoon') }}
      </div>
      <br/>
      <a class="info-btn2" @click="$bvModal.show('inquiryForm')">{{ $t('inquiry') }}</a>
    </div>
    <b-modal modal-class="bg" id="inquiryForm" size="lg" hide-footer>
      <template v-slot:modal-title>
        {{ $t('quickContact') }}
      </template>
      <InquiryForm
        @hide-inquiry-form="hideInquiryForm"
      />
    </b-modal>
  </div>
</template>

<script>
import { authComputed } from '../store/helpers.js'
import InquiryForm from '@/components/forms/InquiryForm.vue'
export default {
  components: { 
    InquiryForm
  },
  computed: {
    ...authComputed
  },
  methods: {
    hideInquiryForm(error) {
      if (error) alert(this.$t('tryLater'))
      else alert(this.$t('inquirySent'))
      this.$bvModal.hide('inquiryForm')
    }
  }
}
</script>

<style lang="scss" scoped>
body,
html {
  height: 100%;
  margin: 0;
}

 img {
  margin-top: 15em;
  width: 8rem;
}
span {
  font-family: "Nasalization", Helvetica, Arial;  
  color: var(--white);
  font-size: 5rem;
  letter-spacing: 2px;
  font-weight: 500;
  margin-left: 8px;
}

.logo-text {
  vertical-align: middle;
  display: inherit;
  margin: auto;
}
#container {
  // background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
  //   url('../assets/static/images/hero.jpg');
  background: linear-gradient(193deg, rgba(12,46,68,1) 0%, rgba(61,88,105,1) 28%, rgba(96,93,108,1) 64%, rgba(251,115,119,1) 100%);
  // height: 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  text-align: center;
}

.bg {
  background: linear-gradient(193deg, rgba(12,46,68,1) 0%, rgba(61,88,105,1) 28%, rgba(96,93,108,1) 64%, rgba(251,115,119,1) 100%);
}

.underline {
  text-decoration: underline;
}
.comingSoon {
  color: var(--bright);
  font-size: 1.8em;
  font-weight: 100;
  padding: 10px;
  letter-spacing: 2px;
}

.info-btn2
{
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn2:hover{
  background: #0C4F60;
}

path {
  stroke: #fff;
  fill: #fff;
  stroke-dasharray: 1800;
  opacity: 10;
  animation: animate 3s cubic-bezier(0, 0.23, 1, 0.1);
}

@keyframes animate {
  0% {
    opacity: 0;
    fill: none;
    stroke-dashoffset: 1800;
  }
  30% {
    opacity: 10;
    fill: none;
    stroke-dashoffset: 1800;
  }
  90% {
    fill: rgba(245, 255, 255, 0);
  }
  100% {
    opacity: 10;
    fill: rgba(255, 255, 255, 1);
    stroke-dashoffset: 0;
  }
}

/* ----  Responsiveness   ----  */
@media (max-width: 500px) {
.info-btn
{
    letter-spacing: 1px;
    padding: 5px 5px;
}
img {
 margin-top: 8em;
}
span {
  font-size: 3.5rem;
  letter-spacing: 1px;
  margin-top: 10rem;
  margin-left: 3px;
}
.comingSoon {
  padding: 10px;
}
}

/* SMARTPHONES LANDSCAPE */
@media only screen and (min-device-width: 480px) and (max-device-width: 820px) and (orientation: landscape) {
span {
  font-size: 2rem;
  letter-spacing: 1px;
  padding: 0;
}
 img {
 margin-top: 2em;
 width: 5rem;
}
}

</style>
